import { Contact } from '@/models'

export default class SelectContactActionPayload {
  contact: Contact | null

  constructor (contact: Contact | null) {
    this.contact = contact
  }
}
